import {
  BOOKING_URL,
  BOOKING_DETAILS,
  BOOKING_LIST,
  BOOKING_STATUS,
} from "../../../config/adminUrlConfig";
import { BookingApiService } from "../../../config/apiServices";
import axios from "axios";
// const token = localStorage.getItem("access_token_admin")
// console.log(token, "token in venue")
export const venueManagerBookingUrl = (id) => {
  // alert(bookToken);
  const token = localStorage.getItem("access_token_admin");

  return axios.get(
    `${BOOKING_URL}?booking_id=${id}`,
    {
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const bookingDetailsUrl = (id) => {
  const token = localStorage.getItem("access_token_admin");
  return axios.get(
    `${BOOKING_DETAILS}/${id}`,
    {
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const fetchBookingList = async ({
  page,
  limit,
  venue,
  sport,
  status,
  search
}) => {
  try {
    const token = localStorage.getItem("access_token_admin");
    const response = await axios.get(
      `${BOOKING_LIST}`,
      {
        params: {
          page: page,
          limit: limit,
          venue_id: venue,
          sport_id: sport,
          search: search,
          status: status,
        },
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    // console.log(response.data?.data,"==>")

    // Return data based on your API structure
    return response.data || [];
  } catch (error) {
    console.error("Error fetching bookings:", error);
    return [];
  }
};

export const bookingStatus = (id, status, remark) => {
  const token = localStorage.getItem("access_token_admin");
  return axios.post(
    `${BOOKING_STATUS}`,
    {
      booking_id: id,
      status: status,
      remark: remark,
    },
    {
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};
